import { getTemplatesByDataType } from "../../../../../constants"

interface UseTemplateLoaderProps {
  dataType: "lead" | "subscription" | "pending_subscription"
  direction: string
  setFormField: (name: string, val: any) => void
}

export const useTemplateLoader = ({
  dataType,
  direction,
  setFormField
}: UseTemplateLoaderProps) => {
  const availableTemplates = getTemplatesByDataType(dataType)

  const loadTemplate = (templateName: string) => {
    const template = availableTemplates.find(t => t.name === templateName)

    if (!template) {
      return
    }

    // Templates are stored as CRM->BB ({"first_name": "details.first_name"})
    // For outgoing, we need to invert to BB->CRM
    // For incoming, use as-is (CRM->BB)
    if (direction === "incoming") {
      // Use template mapping as-is for incoming
      setFormField("field_mapping", template.field_mapping)
    } else {
      // Invert for outgoing: CRM->BB becomes BB->CRM
      const invertedMapping: Record<string, string> = {}
      Object.entries(template.field_mapping).forEach(([crmField, bbField]) => {
        invertedMapping[bbField as string] = crmField
      })
      setFormField("field_mapping", invertedMapping)
    }

    setFormField("type", template.type)
  }

  return {
    availableTemplates,
    loadTemplate
  }
}
